"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M2,8.5 C2,12.9571 6.90514,17.4142 11.857,20.8996 C11.9429,20.9601 12.0571,20.9601 12.143,20.8996 C17.0949,17.4142 22,12.9571 22,8.5 C22,5.46243 19.5376,3 16.5,3 C14.6398,3 12.9954,3.92345 12,5.33692 C11.0046,3.92345 9.36016,3 7.5,3 C4.46243,3 2,5.46243 2,8.5 Z';